import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: 'Is REALV3 a "limited service" or full-service?',
    a: 'Full-service. You get pro photography, MLS exposure, showings coordination, offer negotiation guidance, contracts, disclosures, and closing support — everything a 6% agent provides. The only thing missing is the 6% bill.',
  },
  {
    q: 'How can the fee be just 0.50%?',
    a: "We built REALV3 around a Listing Concierge model instead of a commission-hungry agent roster. Modern tools handle the busy work; our humans focus on you. The savings go straight back to your equity.",
  },
  {
    q: "Do I have to pay the buyer's agent?",
    a: "No — not automatically. Since the 2024 NAR settlement, the buyer's agent fee is between the buyer and their agent. A buyer may ask you to cover it in their offer, and you can accept, negotiate, or decline. We help you score every offer by your net at closing.",
  },
  {
    q: "What's the benefit for the buyer?",
    a: "You don't have to tour homes with a stranger thinking they care about you. That 3–6% buyers traditionally pay in agent fees is money you can negotiate toward your own FHA down payment or closing costs instead. We are helping both parties keep more of what is theirs.",
  },
  {
    q: "How long is my listing contract? Can I cancel?",
    a: "You set the term — 60 days, 90 days, or the standard 6 months. And there are zero cancellation fees. If your plans change or you simply want to walk away, you can. No hostage contracts.",
  },
  {
    q: "Is there any upfront cost?",
    a: "None. There is no listing fee, no setup fee, no marketing fee. You pay the flat 0.50% only at closing — and only if your home actually sells.",
  },
  {
    q: "Who handles paperwork, negotiations, and closing?",
    a: "Your Listing Concierge prepares contracts and disclosures, walks you through every offer, coordinates with title, and tracks every milestone to the closing table. You stay in the driver's seat; we handle the paperwork.",
  },
  {
    q: "How is the Listing Concierge different from a traditional agent?",
    a: "A traditional agent spends most of their week chasing the next client. Your Listing Concierge spends 100% of their time on your sale, with response times you can actually count on and direct 1-on-1 support from our founder for every seller.",
  },
  {
    q: "What areas in Central Florida do you serve?",
    a: "Orlando, Winter Park, Lake Nona, Kissimmee, Clermont, Sanford, and the surrounding Central Florida communities. If you're not sure whether your address qualifies, ask the Concierge — we'll tell you straight up.",
  },
  {
    q: "What happens if I decide not to close on a home?",
    a: "Life happens. If you change your mind before closing, you can withdraw your listing with no penalty and no cancellation fee. As a buyer, your contract still defines your protections (inspection, financing, appraisal periods), and we walk you through your options so you don't lose your earnest money unnecessarily.",
  },
];

const HomeFAQ = () => {
  return (
    <section className="bg-background py-10 md:py-14 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 space-y-3">
          <span className="text-sm font-medium uppercase tracking-wider text-primary">Frequently asked</span>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground">
            Questions, <span className="text-primary">answered straight.</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Honest answers about how REALV3 actually works.
          </p>
        </div>

        <Accordion type="single" collapsible className="bg-card border border-border rounded-2xl px-2 md:px-6 shadow-sm">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-border last:border-0">
              <AccordionTrigger className="text-left text-base md:text-lg font-semibold text-foreground hover:no-underline px-2 md:px-4 py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed px-2 md:px-4 pb-5 text-[15px]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <p className="text-center text-sm text-muted-foreground mt-8">
          Still have questions? Talk to our Listing Concierge — 7 days a week.
        </p>
      </div>
    </section>
  );
};

export default HomeFAQ;
